const AffiliateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 21 21"
      name="AffiliateIcon"
    >
      <path
        fill="currentColor"
        d="M11.482 8.563V5.855H9.815v2.708H6.898c-1.035 0-1.875.84-1.875 1.875v1.459H3.982c-.806 0-1.459.652-1.459 1.458v2.5c0 .805.653 1.458 1.459 1.458h4.166c.806 0 1.459-.653 1.459-1.458v-2.5c0-.806-.653-1.458-1.459-1.458H6.273v-1.459c0-.345.28-.625.625-.625h7.5c.346 0 .625.28.625.625v1.459h-1.875c-.805 0-1.458.652-1.458 1.458v2.5c0 .805.653 1.458 1.458 1.458h4.167c.805 0 1.458-.653 1.458-1.458v-2.5c0-.806-.652-1.458-1.458-1.458h-1.042v-1.459c0-1.035-.839-1.875-1.875-1.875h-2.916Zm5.833 4.584c.115 0 .208.093.208.208v2.5a.208.208 0 0 1-.208.208h-4.167a.208.208 0 0 1-.208-.208v-2.5c0-.115.093-.208.208-.208h4.167Zm-13.333 0h4.166c.116 0 .209.093.209.208v2.5a.208.208 0 0 1-.209.208H3.982a.208.208 0 0 1-.209-.208v-2.5c0-.115.094-.208.209-.208Z"
      ></path>
      <path
        fill="currentColor"
        d="M8.148 4.188a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
      ></path>
    </svg>
  );
};

export default AffiliateIcon;
